export default class ManufacturerService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(manufacturer, options) {
    const response = await fetch(`${this.baseUri}/manufacturer`, {
      body: JSON.stringify(manufacturer),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/manufacturer/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/manufacturer/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/manufacturer`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async import(manufacturers, deleteMissing, options) {
    const response = await fetch(`${this.baseUri}/manufacturer/import?deleteMissing=${deleteMissing}`, {
      body: JSON.stringify(manufacturers),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return response.ok
  }

  async importSql(deleteMissing, options) {
    const response = await fetch(`${this.baseUri}/manufacturer/import/sql?deleteMissing=${deleteMissing}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return response.ok
  }

  async update(id, manufacturer, options) {
    const response = await fetch(`${this.baseUri}/manufacturer/${id}`, {
      body: JSON.stringify(manufacturer),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}